import { useState, useEffect } from 'react';
import { BrowserRouter } from "react-router-dom";

import PageLayout from './components/PageLayout'

import { AppContext } from "./AppContext";

import { PowerBiReport, PowerBiDataset } from './models/models';
import AppOwnsDataWebApi from './services/AppOwnsDataWebApi';
import useAppAccount from './auth/useAppAccount';

const App = () => {

  const { isAuthenticated, displayName } = useAppAccount();

  const [tenantName, setTenantName] = useState<string>(null);
  const [reports, setReports] = useState<PowerBiReport[]>(null);
  const [datasets, setDatasets] = useState<PowerBiDataset[]>(null);
  const [user, setUser] = useState<string>(null);
  const [userCanEdit, setUserCanEdit] = useState<boolean>(null);
  const [userCanCreate, setUserCanCreate] = useState<boolean>(null);
  const [workspaceArtifactsLoading, setWorkspaceArtifactsLoading] = useState<boolean>(null);

  const refreshEmbeddingData = () => {
    const refreshEmbeddingDataAsync = async () => {
      let viewModel = await AppOwnsDataWebApi.GetEmbeddingData();
      setReports(viewModel.reports);
    };
    refreshEmbeddingDataAsync();
  };

  useEffect(() => {

    const getEmbeddingDataAsync = async () => {
      setWorkspaceArtifactsLoading(true);
      try {
        let viewModel = await AppOwnsDataWebApi.GetEmbeddingData();
        setTenantName(viewModel.tenantName);
        setReports(viewModel.reports);
        setDatasets(viewModel.datasets);
        setUser(displayName);
        setUserCanEdit(viewModel.userCanEdit);
        setUserCanCreate(viewModel.userCanCreate);
      } catch (error) {
        console.error("Error loading embedding data from Web API:", error);
        // Fallback to empty tenantName so the UI stops loading and shows the warning
        setTenantName("");
      } finally {
        setWorkspaceArtifactsLoading(false);
      }
    }
    if (isAuthenticated) {
      getEmbeddingDataAsync()
    };

  }, [isAuthenticated]);

  return (
    <AppContext.Provider value={{
      embeddingData: {
        tenantName: tenantName,
        reports: reports,
        datasets: datasets,
        user: user,
        userCanEdit: userCanEdit,
        userCanCreate: userCanCreate,
        workspaceArtifactsLoading: workspaceArtifactsLoading
      },
      refreshEmbeddingData: refreshEmbeddingData,
    }}>

      <BrowserRouter>
        <PageLayout />
      </BrowserRouter>

    </AppContext.Provider>
  )
}

export default App;